import { FormikProps, useFormik } from 'formik';
import { getAddSubscriptionPlanPriceFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { useGetRoles } from '../../../../services/redux/api/rolesApi';
import { FormikValues } from 'formik/dist/types';
import {
  useGetPlans,
  usePostPutSubscriptionPlanPrice,
} from '../../../../services/redux/api/subscriptionsApi';
import { ISubscriptionPlanPrice } from '../../../../types/interfaces/subscription-plan-price';
import { ISubscriptionPlan } from '../../../../types/interfaces/subscription-plan';

export function useAddSubscriptionPlanPriceComponent(
  onClose: () => void,
  price?: ISubscriptionPlanPrice,
) {
  const { t } = useTranslation();
  const { data: roles } = useGetRoles();
  const [postPutSubscriptionPlanPrice, { isLoading }] =
    usePostPutSubscriptionPlanPrice();
  const { data: plans } = useGetPlans();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddSubscriptionPlanPriceFormValidation(t),
    initialValues: {
      stripePriceId: price?.stripePriceId || '',
      value: price?.value || 0,
      plan: price?.plan || null,
      current: price?.current || false,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutSubscriptionPlanPrice({
      id: price?.id,
      body: {
        stripePriceId: values.stripePriceId,
        value: values.value,
        planId: values.plan?.id,
        current: values.current,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  const planOptions: Array<ISubscriptionPlan & { name: string }> = plans?.map(
    (plan) => ({
      ...plan,
      name:
        t(`superAdminDashboard.scope_${plan.scope}`) +
        '-' +
        t(`superAdminDashboard.period_${plan.period}`) +
        '-' +
        plan.stripePlanId,
    }),
  );

  return { formik, roles, isLoading, planOptions };
}
